import {
  SHOP_PAYMENT_TRANSACTION_REQUEST,
  SHOP_PAYMENT_TRANSACTION_SUCCESS,
} from "@/store/actions/shop";
// import { ERROR } from '@/store/actions/ui';
import { ShopService } from "@/common/api";
import BookingPaymentTransaction from "@/model/shop/bookingPaymentTransaction";

const state = {
  loading: false,
  bookingPaymentTransactions: null,
};

const getters = {
  bookingPaymentTransaction: (state) => state.bookingPaymentTransactions,
};

const actions = {
  async [SHOP_PAYMENT_TRANSACTION_REQUEST]({ commit }) {
    commit(SHOP_PAYMENT_TRANSACTION_REQUEST);
    const resp = await ShopService.getBookingPaymentTransaction();
    commit(SHOP_PAYMENT_TRANSACTION_SUCCESS, resp);
    return resp;
  },
};

const mutations = {
  [SHOP_PAYMENT_TRANSACTION_REQUEST](state) {
    state.loading = true;
  },
  [SHOP_PAYMENT_TRANSACTION_SUCCESS](state, resp) {
    console.log("SHOP_PAYMENT_TRANSACTION_SUCCESS", resp);
    if (resp?.data) {
      state.bookingPaymentTransactions = new BookingPaymentTransaction(resp.data)
    }

    state.loading = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
